import { createSelector } from 'reselect';

export const LOADING = 'LOADING' as const;
export const FAILED = 'FAILED' as const;
export const LOADED = 'LOADED' as const;

type ProjectHasSubtaskValidators =
	| {
			status: typeof LOADING;
	  }
	| {
			status: typeof FAILED;
	  }
	| {
			status: typeof LOADED;
			value: boolean;
	  };

type Validators = {
	projectHasSubtaskValidators: ProjectHasSubtaskValidators;
};

const hasSubtaskValidators = (hasValidators: ProjectHasSubtaskValidators) =>
	hasValidators.status === LOADED && hasValidators.value;

const unknown = (hasValidators: ProjectHasSubtaskValidators) =>
	hasValidators.status === LOADING || hasValidators.status === FAILED;

export const projectHasSubtaskValidatorsSelector = createSelector(
	// @ts-expect-error - TS2571 - Object is of type 'unknown'.
	(state) => state.validators,
	(validators: Validators) => {
		const val = validators.projectHasSubtaskValidators;
		return hasSubtaskValidators(val) || unknown(val);
	},
);
